import * as React from 'react';

import { Image } from '@cian/ui-kit';

import DOC from './assets/DOC.svg';
import DOCX from './assets/DOCX.svg';
import JPEG from './assets/JPEG.svg';
import PDF from './assets/PDF.svg';
import XLS from './assets/XLS.svg';
import FILE from './assets/FILE.svg';

export enum FileTypes {
  DOC = 'doc',
  DOCX = 'docx',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PDF = 'pdf',
  XLS = 'xls',
  FILE = 'file',
}

const FilesIcons: Record<FileTypes, string> = {
  [FileTypes.DOC]: DOC,
  [FileTypes.DOCX]: DOCX,
  [FileTypes.JPEG]: JPEG,
  [FileTypes.JPG]: JPEG,
  [FileTypes.PDF]: PDF,
  [FileTypes.XLS]: XLS,
  [FileTypes.FILE]: FILE,
};

export interface IFileProps {
  fileType: FileTypes;
}

export const File: React.FC<IFileProps> = ({ fileType }) => {
  const type = fileType.toLowerCase() as FileTypes;

  return <Image src={FilesIcons[type]} width={40} height={40} />;
};

File.displayName = 'File';
